import * as React from "react";
import { HelpCircle } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import {
  DependencyHealthStatus,
  DependencyHealthStatusColors,
  DependencyHealthStatusIcons,
  DependencyHealthStatusLabels,
} from "../../models/Client/DependencyHealthStatus";
import { convertUtcToLocal } from "../../helpers/CommonHelpers";

interface HealthStatusChipProps {
  status: DependencyHealthStatus;
  label: string;
  lastHealthCheckUtc: string;
}

export const HealthStatusChip: React.FC<HealthStatusChipProps> = ({
  status,
  label,
  lastHealthCheckUtc,
}: HealthStatusChipProps) => {
  const isUnknown = !lastHealthCheckUtc || lastHealthCheckUtc === "0001-01-01T00:00:00Z";
  const healthText = isUnknown
    ? "Unknown"
    : DependencyHealthStatusLabels[status] + " - " + convertUtcToLocal(lastHealthCheckUtc);

  const Icon = isUnknown ? HelpCircle : DependencyHealthStatusIcons[status];

  return (
    <div className="flex items-center gap-1 mb-1">
      <span className="text-xs min-w-[120px] text-[0.75rem]">
        {label}:
      </span>
      <Badge
        variant={isUnknown ? "neutral" : DependencyHealthStatusColors[status]}
      >
        <Icon className="size-3" />
        {healthText}
      </Badge>
    </div>
  );
};
